import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { BranchFranchiseCompareContext } from './branchServicesProvider';
import { withStyles } from '@material-ui/styles';
import { Grid, Typography, TableContainer } from '@material-ui/core';
import AppContext from '../../../../App/AppContext';
import DashboardDataRow from './maDashboardDataRows';
import DashboardHeaderRow from './maDashboardHeaderRow';
import MADashFooterRow from './maDashboardFooter';

const useStyles = makeStyles({
    table: {
        minWidth: '100%',
        border: '1px dotted lightgrey'
    },
    header: {
        background: '#2a4d90',
        color: 'white',
        padding: '1px 5px',
        fontWeight: 500,
        fontSize: '13px',
        border: '1px solid black'
    },
    body: {
        padding: '1px 5px',
        fontWeight: 500,
        fontSize: '13px',
        border: '1px solid #ccc'
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 10,
        padding: '4px',
        fontWeight: 700,
        alignItems: 'center',
        border: '1px solid black',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        border: 'none'
    }
}))(TableCell);

export default function ServiceTable() {
    const { showToast } = useContext(AppContext);
    const {
        headerArray,
        state,
        categoryList,
        dataList,
        calculateKIP,
        getBranchData,
        getFrenChiseData,
        screenDetails,
        getOverallAccountCodeData,
        BranchNullEntry,
        FrenchiseNullEntry,
        calculateOverallTotal,
        getCalculatedBranchData,
        getCalculatedFranchiseData,
        ByPassCalculationsTotal
    } = useContext(BranchFranchiseCompareContext);

    const UnderLineRow = () => {
        return (
            <TableRow>
                <StyledTableCell style={{ padding: '5px 40px', background: 'white', border: 'none' }} align="center" colSpan={7}>
                    <hr className="sep-2" />
                </StyledTableCell>
            </TableRow>
        );
    };

    return (
        <Grid container spacing={2} justifyContent="space-evenly">
            {state.branchNewList.length === 0 ? (
                <Grid item xs={12}>
                    <Typography>Please Select Branch</Typography>
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <Grid container spacing={1} justifyContent="flex-start">
                        {state.branchNewList?.map((branchObj, branchIndex = 0) => {
                            let mainHeader = [];
                            mainHeader = headerArray;

                            return (
                                <>
                                    {state?.franchise?.length > 0 ? (
                                        state?.franchise?.map((fren, index) => {
                                            return (
                                                <Grid item xs={12} sm={12} md={12} xl={4} lg={6} key={`fernKey${index}`}>
                                                    <TableContainer
                                                        style={{ padding: 5, borderRadius: 5, maxHeight: 'calc(100vh - 263px)' }}
                                                        className="custom-scroll"
                                                    >
                                                        <Table className={'module'} aria-label="simple table" stickyHeader>
                                                            <TableHead>
                                                                {/* Row 1 */}
                                                                <TableRow>
                                                                    <StyledTableCell
                                                                        colSpan={7}
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: '1px solid #ccc',
                                                                            padding: 0,
                                                                            position: 'sticky',
                                                                            top: -5,
                                                                            zIndex: 3
                                                                        }}
                                                                    >
                                                                        {branchObj.name}
                                                                    </StyledTableCell>
                                                                </TableRow>

                                                                {/* Row 2 */}
                                                                <TableRow>
                                                                    <StyledTableCell
                                                                        colSpan={7}
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: '1px solid #ccc',
                                                                            padding: 0,
                                                                            position: 'sticky',
                                                                            top: 21, // height of row 1
                                                                            zIndex: 2
                                                                        }}
                                                                    >
                                                                        {fren.name}
                                                                    </StyledTableCell>
                                                                </TableRow>

                                                                {/* Row 3 (main header) */}
                                                                <TableRow>
                                                                    {mainHeader?.map((m, i) => (
                                                                        <StyledTableCell
                                                                            key={i}
                                                                            align={m.align}
                                                                            style={{
                                                                                backgroundColor: screenDetails.bgColor,
                                                                                color: screenDetails.txtColor,
                                                                                border: '1px solid #ccc',
                                                                                fontSize: 10,
                                                                                position: 'sticky',
                                                                                top: 46, // height of row 1 + row 2
                                                                                zIndex: 1
                                                                            }}
                                                                            width={i === 0 ? '800px' : i === 4 ? 50 : '100px'}
                                                                        >
                                                                            {m.name}
                                                                        </StyledTableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {categoryList?.map((k = {}, i) => {
                                                                    const branchId = branchObj.id;
                                                                    const isCalculated = k.calculated == 1;
                                                                    const isTotalCalculated = k.calculated == 2;
                                                                    let categoryCount = 0;
                                                                    let totalKpi = 0;
                                                                    const frenNullEntry = FrenchiseNullEntry(
                                                                        dataList,
                                                                        fren.id,
                                                                        k.categoryId,
                                                                        branchObj.id,
                                                                        k.calculated
                                                                    );
                                                                    const franchiseList = getFrenChiseData(branchObj.id, k.categoryId, fren.id);
                                                                    const calculationList = getCalculatedFranchiseData(
                                                                        branchObj.id,
                                                                        fren.id,
                                                                        isCalculated || isTotalCalculated,
                                                                        k.calculation,
                                                                        k.categoryId
                                                                    );

                                                                    const rowData = isTotalCalculated
                                                                        ? []
                                                                        : isCalculated
                                                                        ? calculationList.filter((item) => item.catID === k.categoryId)
                                                                        : franchiseList;

                                                                    const rawTotals = calculateOverallTotal(k.categoryId, branchId, fren.id);
                                                                    const calcTotals = ByPassCalculationsTotal(calculationList, k.categoryId, fren.id);

                                                                    const totals = {
                                                                        actual:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_actual
                                                                                : rawTotals.Total_actual,
                                                                        budget:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_budget
                                                                                : rawTotals.Total_budget,
                                                                        actualLY:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_actualLY
                                                                                : rawTotals.Total_actualLY,
                                                                        varLY:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_varLY
                                                                                : rawTotals.Total_varLY,
                                                                        variance:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_variance
                                                                                : rawTotals.Total_variance
                                                                    };

                                                                    return (
                                                                        <React.Fragment key={`category-${k.categoryId}-${i}`}>
                                                                            <DashboardHeaderRow config={k} />

                                                                            {rowData.map((data, idx) => {
                                                                                const kpiValue = calculateKIP(totals.actual, data.actual);
                                                                                totalKpi += kpiValue;
                                                                                categoryCount++;

                                                                                return (
                                                                                    <DashboardDataRow
                                                                                        key={`row-${data.mappingCategoryID || idx}`}
                                                                                        data={data}
                                                                                        k={k}
                                                                                        kpiValue={kpiValue}
                                                                                        getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                        showToast={showToast}
                                                                                        branchId={branchObj.id}
                                                                                        frenchise={fren.id}
                                                                                    />
                                                                                );
                                                                            })}

                                                                            {frenNullEntry
                                                                                .sort((a, b) => a.sequence - b.sequence)
                                                                                .map((data, idx) => (
                                                                                    <DashboardDataRow
                                                                                        key={`null-row-${data.mappingCategoryID || idx}`}
                                                                                        data={data}
                                                                                        k={k}
                                                                                        kpiValue={0}
                                                                                        getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                        showToast={showToast}
                                                                                        isNull={true}
                                                                                        branchId={branchObj.id}
                                                                                        frenchise={fren.id}
                                                                                    />
                                                                                ))}

                                                                            <MADashFooterRow
                                                                                config={k}
                                                                                categoryCount={categoryCount}
                                                                                totals={{
                                                                                    ...totals,
                                                                                    totalKpi
                                                                                }}
                                                                            />

                                                                            {i < categoryList.length - 1 && <UnderLineRow />}
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            );
                                        })
                                    ) : (
                                        <Grid item xs={12} sm={12} md={12} xl={4} lg={6}>
                                            <TableContainer style={{ padding: 5, borderRadius: 5, maxHeight: 'calc(100vh - 263px)' }} className="custom-scroll">
                                                <Table className={'module'} aria-label="simple table" stickyHeader>
                                                    <TableHead>
                                                        {/* Row 1 */}
                                                        <TableRow>
                                                            <StyledTableCell
                                                                colSpan={7}
                                                                align="center"
                                                                style={{
                                                                    backgroundColor: screenDetails.bgColor,
                                                                    color: screenDetails.txtColor,
                                                                    border: '1px solid #ccc',
                                                                    padding: 0,
                                                                    position: 'sticky',
                                                                    top: -5,
                                                                    zIndex: 3
                                                                }}
                                                            >
                                                                {branchObj.name}
                                                            </StyledTableCell>
                                                        </TableRow>

                                                        {/* Row 3 (main header) */}
                                                        <TableRow>
                                                            {mainHeader?.map((m, i) => (
                                                                <StyledTableCell
                                                                    key={i}
                                                                    align={m.align}
                                                                    style={{
                                                                        backgroundColor: screenDetails.bgColor,
                                                                        color: screenDetails.txtColor,
                                                                        border: '1px solid #ccc',
                                                                        fontSize: 10,
                                                                        position: 'sticky',
                                                                        top: 21, // height of row 1 + row 2
                                                                        zIndex: 1
                                                                    }}
                                                                    width={i === 0 ? '700px' : i === 4 ? '80px' : '120px'}
                                                                >
                                                                    {m.name}
                                                                </StyledTableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {categoryList?.map((k = {}, i) => {
                                                            const branchId = branchObj.id;
                                                            const isCalculated = k.calculated == 1;
                                                            const isTotalCalculated = k.calculated == 2;
                                                            const branchData = getBranchData(branchId);

                                                            let categoryCount = 0;
                                                            let totalKpi = 0;

                                                            const branchWithNoData = BranchNullEntry(
                                                                branchData,
                                                                dataList,
                                                                k.categoryId,
                                                                branchId,
                                                                k.calculated
                                                            );
                                                            const calculationList = getCalculatedBranchData(
                                                                branchId,
                                                                k.calculated || isTotalCalculated,
                                                                k.calculation,
                                                                k.categoryId
                                                            );

                                                            const rawTotals = calculateOverallTotal(k.categoryId, branchId);
                                                            const calcTotals = ByPassCalculationsTotal(calculationList, k.categoryId);

                                                            const totals = {
                                                                actual: isCalculated || isTotalCalculated ? calcTotals.calTotal_actual : rawTotals.Total_actual,
                                                                budget: isCalculated || isTotalCalculated ? calcTotals.calTotal_budget : rawTotals.Total_budget,
                                                                actualLY:
                                                                    isCalculated || isTotalCalculated ? calcTotals.calTotal_actualLY : rawTotals.Total_actualLY,
                                                                varLY: isCalculated || isTotalCalculated ? calcTotals.calTotal_varLY : rawTotals.Total_varLY,
                                                                variance:
                                                                    isCalculated || isTotalCalculated ? calcTotals.calTotal_variance : rawTotals.Total_variance
                                                            };

                                                            const dataListToRender = (isTotalCalculated ? [] : k.calculated ? calculationList : branchData)
                                                                .filter((item) =>
                                                                    k.calculated ? item.catID === k.categoryId : item.maDashboardCategoryId === k.categoryId
                                                                )
                                                                .sort((a, b) => a.sequence - b.sequence);

                                                            return (
                                                                <React.Fragment key={`category-${k.categoryId}-${i}`}>
                                                                    <DashboardHeaderRow config={k} />
                                                                    {dataListToRender.map((data, idx) => {
                                                                        const actualValue = data.actual;
                                                                        const kpiValue = calculateKIP(totals.actual, actualValue);
                                                                        totalKpi += kpiValue;
                                                                        categoryCount++;

                                                                        return (
                                                                            <DashboardDataRow
                                                                                key={`data-${data.mappingCategoryID || idx}`}
                                                                                data={data}
                                                                                k={k}
                                                                                kpiValue={kpiValue}
                                                                                getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                showToast={showToast}
                                                                                branchId={branchObj.id}
                                                                            />
                                                                        );
                                                                    })}
                                                                    {branchWithNoData
                                                                        .sort((a, b) => a.sequence - b.sequence)
                                                                        .map((data, idx) => (
                                                                            <DashboardDataRow
                                                                                key={`nodata-${data.mappingCategoryID || idx}`}
                                                                                data={data}
                                                                                k={k}
                                                                                kpiValue={0}
                                                                                getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                showToast={showToast}
                                                                                isNull={true}
                                                                                branchId={branchObj.id}
                                                                            />
                                                                        ))}
                                                                    <MADashFooterRow
                                                                        config={k}
                                                                        categoryCount={categoryCount}
                                                                        totals={{
                                                                            ...totals,
                                                                            totalKpi
                                                                        }}
                                                                    />

                                                                    {i < categoryList.length - 1 && <UnderLineRow />}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    )}
                                </>
                            );
                        })}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}
